<template>
  <b-card no-body class="step">
    <slot name="header">
      <b-card-header>
        {{ step.name }}
      </b-card-header>
    </slot>
    <slot>
      <!-- This use bootstrap view in a non-standard way. :value is map to v-model -->
      <!-- https://bootstrap-vue.js.org/docs/components/tabs/#external-controls describes using v-model -->
      <!-- https://stackoverflow.com/questions/42260233/vue-js-difference-between-v-model-and-v-bind describes v-model and :value usage -->
      <b-tabs
        v-for="section of (step.sections || []).filter(s => s)"
        :key="section.name"
        :value="getSelectedCategoryIndexInSection(section)"
      >
        <b-tab
          v-for="category of section.categories"
          :key="category.name"
          :title="category.name !== step.name ? category.name : ''"
        >
          <b-card
            v-for="item of category.items"
            :key="item.guid || item.name"
            :img-src="item.thumbnail"
            no-body
            class="linked-card"
            :class="{ active: item.selected }"
          >
            <div
              v-if="step.name === specialCases.stepNames.thermalConstruction"
              class="card-body"
            >
              <ul style="list-style: none; padding-inline-start: 0px; margin-bottom: 0px">
                <li>R-{{ item.rValue }}</li>
                <li>{{ item.modelNumber }}</li>
                <li>{{ item.gauge }}</li>
                <li>{{ item.thickness }}</li>
                <li>{{ item.constructionType }}</li>
                <li v-if="item && item.windLoadInformation">
                  {{ item.windLoadInformation }}</li>
                <li>{{ item.doorType }}</li>
                <li>{{ item.insulation }}</li>
              </ul>
            </div>
            <div v-else class="card-body">
              {{ item.name }}
            </div>
          </b-card>
        </b-tab>
      </b-tabs>
    </slot>
  </b-card>
</template>

<script>
import { mapState } from 'vuex';
import get from 'lodash.get';

export default {
  name: 'step',
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState([
      'specialCases',
    ]),
  },
  methods: {
    get,
    getSelectedCategoryIndexInSection(section) {
      return section.categories.findIndex(item => item.selected);
    },
  },
};
</script>

<style lang="scss">
.step {
  .collapse,
  .tabs {
    min-height: 1px; // IE11
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Step.vue